/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'attach': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17.005 5.48a4.25 4.25 0 00-6.01 0l-6.87 6.87a.75.75 0 11-1.06-1.061l6.87-6.87a5.75 5.75 0 018.13 8.132l-7.542 7.543a4.083 4.083 0 11-5.774-5.775l6.601-6.602a2.417 2.417 0 113.418 3.418l-5.69 5.69a.75.75 0 01-1.061-1.06l5.69-5.69a.917.917 0 00-1.296-1.297L5.81 15.38a2.583 2.583 0 003.654 3.653l7.542-7.543a4.25 4.25 0 000-6.01z" _fill="#CC2C34"/>'
  }
})
